export const ldStubs = {
  enableArchiveGuardrails: true,
  enableDataProductActions: false,
  enableDataProductApply: false,
  enableDeleteDataset: true,
  enableEditActiveDataProduct: true,
  enableNotificationRulesRecon: true,
  enablePartialProfiling: true,
  showCustomConnectors: true,
  showCustomFilenamePatterns: true,
  showDataProductAddSubscribers: true,
  showDataProductAddSubscription: true,
  showDataProductOverviewDestinations: false,
  showDatasetDeliveryDeadlines: true,
  showDatasetDocumentsView: true,
  showDatasetScheduleView: true,
  showDatasetTableLocations: true,
  showDeactivateOrg: true,
  showDelimitedNormalizerSettings: false,
  showDeployDatasets: true,
  showDeploymentLogs: false,
  showFrameProfilingNotification: false,
  showHealthDashboardErrorLogs: true,
  showHealthDashboardV2: true,
  showInferredScheduleCard: true,
  showInferredScheduleHeatmap: false,
  showInferredScheduleNotificationButton: false,
  showJsonNormalizerSettings: false,
  showMetadataNavigator: true,
  showMyDataDatasetStates: true,
  showNotificationPreferences: true,
  showNotificationsCenter: false,
  showOrgActivityOverview: false,
  showOrgAutoDeletionBanner: true,
  showOrgDataLicenses: true,
  showOrgExposureCard: false,
  showOrgsDetails: true,
  showPauseDataProduct: true,
  showProfileLogs: false,
  showProfiledDatasets: true,
  showProfilerSearch: false,
  showProfilingDeliveriesModal: false,
  showRearrangeDatasets: false,
  showRerunDatasetDelivery: true,
  showSchemaVersions: true,
  showSubscriptionPlans: true,
  showTestResults: false,
  showTestStep: true,
  showUsagePlanStats: false,
  showXmlNormalizerSettings: false,
  useDataProductsV4: true,
  useFivePartCron: true,
};
